import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { stripHtmlTags } from '@change-corgi/core/html';

import { usePageMeta } from './usePageMeta';

export const PageMeta: React.FC = () => {
	const {
		data: { objective, description },
	} = usePageMeta();

	return (
		<Helmet>
			<title>{`${objective} · Movement`}</title>
			<meta name="description" content={stripHtmlTags(description)} />
		</Helmet>
	);
};
